export class Action {
  constructor(public type: string, public payload: { [key: string]: string | boolean | any[] | any }) {
  }
}
